import { Link as RouterLink } from "react-router-dom";
// @mui
import { styled } from "@mui/material/styles";
import { Card, Link, Container, Typography, Divider, Box } from "@mui/material";
// hooks
import useResponsive from "../hooks/useResponsive";
// components
import Page from "../components/Page";
import Logo from "../components/Logo";
// sections
import { RegisterForm } from "../sections/auth/register";
import AuthSocial from "../sections/auth/AuthSocial";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import i18next from "i18next";
import { useSelector } from "react-redux";
import logo from "../logo.svg";

// ----------------------------------------------------------------------

const RootStyle = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

const HeaderStyle = styled("header")(({ theme }) => ({
  top: 0,
  zIndex: 9,
  lineHeight: 0,
  width: "100%",
  display: "flex",
  alignItems: "center",
  position: "absolute",
  padding: theme.spacing(3),
  justifyContent: "space-between",
  [theme.breakpoints.up("md")]: {
    alignItems: "flex-start",
    padding: theme.spacing(7, 5, 0, 7),
  },
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  margin: theme.spacing(2, 0, 2, 2),
  height: "96vh",
  border:"none",
  boxShadow:"none"
}));

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function Register() {
  const smUp = useResponsive("up", "sm");

  const mdUp = useResponsive("up", "md");
  const { translate } = useSelector((state) => state);
  const { t } = useTranslation();
  useEffect(() => {
    i18next.changeLanguage(translate);
  }, [translate]);
  return (
    <Page
      title="Register"
      sx={{
        backgroundColor: "#FDFDFD",
      }}
    >
      <RootStyle>
        {/* <HeaderStyle>
          <Logo />
          // {smUp && (
          //   <Typography variant="body2" sx={{ mt: { md: -2 } }}>
          //     Already have an account? {""}
          //     <Link variant="subtitle2" component={RouterLink} to="/login">
          //       Login
          //     </Link>
          //   </Typography>
          // )}
        </HeaderStyle> */}

        {mdUp && (
          <SectionStyle>
            <img src={logo} alt="Tomaládácá Logotipo"></img>
          </SectionStyle>
        )}

        <Container>
          <ContentStyle>
           
            <Typography variant="h1" gutterBottom align="center" style={{ fontSize: '18px' }}>
              {t("registerTitle")}!{" "}
            </Typography>
{/* 
            <Typography sx={{ color: "text.secondary", mb: 5 }} align="justify">
              Qui tempore quidem nulla pariatur aut enim sapiente. Modi error
              omnis. Ex deserunt ut aperiam amet quas iste et non. Aceder{" "}
            </Typography> */}

            <RegisterForm t={t} />

            {/* <Divider sx={{ my: 3 }}>
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                {t("authOptions")}
              </Typography>
            </Divider>
            <AuthSocial /> */}
            <Typography
              variant="body2"
              align="center"
              sx={{ color: "text.secondary", mt: 3 }}
            >
              {t("haveAccount")}{" "}
              <Link variant="subtitle2" to="/" component={RouterLink}>
                {t("loginWith")}{" "}
              </Link>
            </Typography>

            {/* {!smUp && (
              <Typography variant="body2" sx={{ mt: 3, textAlign: "center" }}>
                Already have an account?{" "}
                <Link variant="subtitle2" to="/" component={RouterLink}>
                  Login
                </Link>
              </Typography>
            )} */}
          </ContentStyle>
        </Container>
      </RootStyle>
    </Page>
  );
}
